<template>
  <!-- ヘッダーコンテンツ: サイト名,サイト選択 -->
  <div v-show="!headerData.isSystemAdmin" class="l-header-site">
    <p class="l-header-site__label">
      <a>{{
        headerData.services[headerData.selectedServiceId]
      }}</a>
    </p>
    <a
      class="c-btn c-btn--square c-btn--site-select c-btn--white-alpha u-wh20"
      @click="onToggle()"
    >
      <div class="c-icon c-icon--blue-2 u-wh10">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <use xlink:href="/assets/img/sprite.svg#arrow-bottom" />
        </svg>
      </div>
    </a>
    <div
      class="l-header-site__list"
      :class="{'is-active': isOpen}"
    >
      <div class="c-balloon">
        <div class="c-balloon__arrow"></div>
        <div class="c-balloon__close" @click="onCloseClick()">
          <div class="c-icon u-wh22 c-icon--gray-3">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use xlink:href="/assets/img/sprite.svg#close-thin" />
            </svg>
          </div>
        </div>
        <div class="c-balloon-title">
          <p class="c-balloon-title__label" style="cursor:pointer;" @click="goToServiceList">
            プロジェクト一覧へ
          </p>
        </div>
        <ul class="c-balloon-list">
          <li
            v-for="(serviceName, serviceId) in headerData.services"
            :key="serviceId"
            class="c-balloon-list__item c-balloon-list__item--ellipsis"
            :class="
              serviceId == headerData.selectedServiceId
                ? 'c-balloon-list__item--current'
                : 'c-balloon-list__item'
            "
            @click="onServiceClick($event, serviceId)"
          >
            <a>{{ serviceName }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    headerData: Object,
  },
  emits: ["open"],
  data: function () {
    return {
      sites: null,
      errorMessage: '',
      isOpen: false,
      isError: false,
    };
  },
  mounted: function () {
    this.sites = $(".l-header-site__list");
  },
  methods: {
    close: function(){
      this.sites.removeClass('is-active');
    },
    onToggle: function () {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$emit("open");
      }
    },
    onCloseClick: function () {
      this.isOpen = false;
    },
    goToServiceList: function () {
      location.href = "/coins-admin/project/list";
    },
    onServiceClick: function (event, serviceId) {
      event.preventDefault();
      if (serviceId != this.headerData.selectedServiceId) {
        const data = {
          service_id: serviceId,
        };

        const MAX_RETRIES = 3;
        const self = this;

        // サービスのセット
        const selectService = (data, retryCount = 0) => {
          axios
            .post("/api/system/service", data)
            .then((res) => {
              if (res.data.result == "OK") {
                if (res.data.service_id == serviceId) {
                  location.href = "/coins-admin";
                } else {
                  // リトライ
                  if (retryCount < MAX_RETRIES) {
                    setTimeout(() => selectService(data, retryCount + 1), 1000);
                  } else {
                    self.isError = true;
                    self.errorMessage = 'エラーが発生しました';
                  }
                }
              } else {
                self.isError = true;
                self.errorMessage = '指定サイト情報が存在しません';
              }
            })
            .catch((error) => {
              self.isError = true;
              self.errorMessage = '指定サイト情報が存在しません';
              self.handleHttpError(error);
            });
        }

        selectService(data);
      }
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },
};
</script>
